module.exports = __webpack_public_path__ + "static/media/star_fill.24e96dba.svg";